/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AssignActorRoleRequest } from "../../roles/types/AssignActorRoleRequest";
export const UserCreateAndInviteRequest = core.serialization.object({
    email: core.serialization.string(),
    name: core.serialization.string(),
    actorRoles: core.serialization.list(AssignActorRoleRequest),
});
